import { DetailedHTMLProps, FC, HTMLAttributes } from 'react'
import styled from 'styled-components'

const DotsButton = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) => (
  <DotsWrapper {...props}>
    <Dot />
    <Dot />
    <Dot />
  </DotsWrapper>
)

const Dot = styled.div`
  background-color: black;
  width: 3.33px;
  height: 3.33px;
  border-radius: 50%;
`

const DotsWrapper = styled.div`
  width: 20px;
  height: 30px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
` as FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>>

export default DotsButton
